import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Card from '@mui/material/Card';
import { CardContent, Divider, Stack, Typography } from '@mui/material';
import { Box } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';

import { getProdCategories } from '../../../controllers/settings/inventoryControllers';
import Button from '../../../components/buttons/Button';
import ScreenWrapper from '../../../components/wrappers/ScreenWrapper';
import {
  TableRowStyled,
  TbRowHeaderStyled,
} from '../../../components/styled/TableRowStyled';
import {
  TbCellBody,
  TbCellHeader,
} from '../../../components/styled/TableCellStyled';

const ProductCategoryListPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const catsQuery = useQuery(['prodCategories'], getProdCategories);
  const { data = [], isLoading, isError } = catsQuery;

  // console.log('data', data);

  return (
    <Card sx={{ minWidth: 275, paddingX: 4 }}>
      <CardContent>
        <Stack pb={2} direction={'row'} alignItems={'center'} spacing={2}>
          <Box flex={1}>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              alignItems={'center'}>
              <Grid xs={8}>
                <Typography
                  sx={{ fontSize: 20 }}
                  color="text.primary"
                  gutterBottom>
                  {t('settingStack.productCategories')} ({data.length})
                </Typography>
              </Grid>
              <Grid xs={4}>
                {/* <InputForm
                  size="small"
                  label={'search account by name, code or type...'}
                  onChangeText={(v: string) => onSearch(String(v))}
                /> */}
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Button
              title="Add Product Category"
              onClick={() => navigate('/settings/product-categories/create')}
            />
          </Box>
        </Stack>

        <Divider />

        <ScreenWrapper {...{ isLoading, isError, isEmpty: !data.length }}>
          <TableContainer>
            <Table aria-label="table">
              <TableHead>
                <TbRowHeaderStyled>
                  <TbCellHeader sx={{ width: 36 }}>SN</TbCellHeader>
                  <TbCellHeader>Product Category Name</TbCellHeader>
                  {/* <TableCell align="right">Created At</TableCell> */}
                </TbRowHeaderStyled>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRowStyled key={row.id}>
                    <TbCellBody sx={{ width: 36 }}>{index + 1}</TbCellBody>

                    <TbCellBody>{row.name}</TbCellBody>
                    {/* <TableCell align="right">{row.createdAt}</TableCell> */}
                  </TableRowStyled>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </ScreenWrapper>
      </CardContent>
    </Card>
  );
};

export default ProductCategoryListPage;
